import React from "react";
import Tooltip from "@mui/material/Tooltip";
import PrimaryButton, {
  PrimaryButtonProps,
  PrimaryButtonType,
} from "../PrimaryButton/PrimaryButton";
import { useCapabilities } from "../../../setup/context/capabilitiesContext";

/**
 * Drop-in replacement for PrimaryButton on action sites (write operations).
 * Automatically enforces view-only for staff-engineer tier:
 * - staff-engineer sees a disabled button with a bilingual tooltip
 * - All other staff tiers behave identically to PrimaryButton
 */
const ActionButton: React.FC<PrimaryButtonProps> = ({
  buttonType,
  ...props
}) => {
  const { canAct } = useCapabilities();

  if (!canAct) {
    return (
      <Tooltip
        title="عرض فقط — لا تملك صلاحية التنفيذ / View only — no action permission"
        arrow
        placement="top">
        <span>
          <PrimaryButton
            {...props}
            disabled
            buttonType={PrimaryButtonType.DISABLED}
          />
        </span>
      </Tooltip>
    );
  }

  return <PrimaryButton {...props} buttonType={buttonType} />;
};

export default ActionButton;
